<div class="wrapper">

  <div class="cuerpo">

    <h1 class="tp-navandu line-navandu">INICIAR PROCESO</h1>
    <div class="input-field col s12 buscador">
      <input id="filter" type="text" (keyup)="applyFilter($event)" [(ngModel)]="textToSearch">
      <label for="filter" data-error="Ingrese un dato valido" data-success=""> 
         <button mat-icon-button type="button" (click)="search()">
             <i class="material-icons">search</i>
         </button>
       </label>
    </div>

    @if (loading) {
    <app-spinner></app-spinner>
    } @else {
    <table mat-table [dataSource]="dataSource" class="tabla tabla-inicio-procesos">
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef> Nombre </th>
        <td mat-cell *matCellDef="let element"> {{element.name}}</td>
      </ng-container>
      <ng-container matColumnDef="description">
        <th mat-header-cell *matHeaderCellDef> Descripción </th>
        <td mat-cell *matCellDef="let element"> {{element.description}} </td>
      </ng-container>
      <ng-container matColumnDef="templates">
        <th mat-header-cell *matHeaderCellDef> Plantilllas Asociadas </th>
        <td mat-cell *matCellDef="let element">
          @for (template of element.templates; track template) {
          <p>{{template.name}}</p>
          }
      </ng-container>
      <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef> Acción </th>
        <td mat-cell *matCellDef="let element">
          <button (click)="view(element.uuid)" mat-icon-button
            aria-label="Example icon button with a vertical three dot icon">
            <div class="tooltip3">
              <mat-icon>send</mat-icon>
              <span class="tooltiptext3">Iniciar proceso</span>
            </div>
          </button>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
    }
    <mat-paginator [pageSizeOptions]="[20, 50, 100]" showFirstLastButtons></mat-paginator>

  </div>

  @if (viewForm) {
  <div class="ver-firmante">
    <form name="entrar" class="formulario form-gen-doc" autocomplete="off" [formGroup]="processConfigForm"
      (ngSubmit)="onSubmit()">
      <div class="info-destinatario">
        <h2 class="tp-navandu"> INFORMACIÓN DEL DESTINATARIO </h2>
        <div class="flex-row">
          <mat-form-field class="example-full-width">
            <mat-label>Número de documento</mat-label>
            <input type="text" matInput formControlName="addressee_document" required [matAutocomplete]="auto">
            <mat-autocomplete #auto="matAutocomplete">
              @for (option of filteredOptions | async; track option) {
              <mat-option [value]="option.idn">
                {{option.idn}}
              </mat-option>
              }
            </mat-autocomplete>
          </mat-form-field>
          <mat-form-field>
            <mat-label>Tipo de documento</mat-label>
            <mat-select required formControlName="addressee_document_type">
              <mat-option value="Alias">Alias</mat-option>
              <mat-option value="DNI">DNI</mat-option>
              <mat-option value="NIF">NIF</mat-option>
              <mat-option value="NIE">NIE</mat-option>
              <mat-option value="CIF">CIF</mat-option>
              <mat-option value="PASS">PASS</mat-option>
              <mat-option value="RUC">RUC</mat-option>
              <mat-option value="Cedula">Cedula</mat-option>
              <mat-option value="Otro">Otro</mat-option>
            </mat-select>
            @if (processConfigForm.controls.addressee_document_type.hasError('required')) {
            <mat-error>
              Tipo de documento <strong>requerido</strong>
            </mat-error>
            }
          </mat-form-field>
        </div>
        <div class="flex-row">
          <mat-form-field class="example-full-width">
            <mat-label>Nombre</mat-label>
            <input type="text" matInput formControlName="addressee_name" required [matAutocomplete]="autoName">
            @if (processConfigForm.controls.addressee_name.hasError('required')) {
            <mat-error>
              Nombre <strong>requerido</strong>
            </mat-error>
            }
            <mat-autocomplete #autoName="matAutocomplete">
              @for (option of filteredOptionsName | async; track option) {
              <mat-option [value]="option.name">
                {{option.name}}
              </mat-option>
              }
            </mat-autocomplete>
          </mat-form-field>
          <mat-form-field class="example-full-width">
            <mat-label>Apellido</mat-label>
            <input type="text" matInput formControlName="addressee_last_name" required [matAutocomplete]="autoLastName">
            @if (processConfigForm.controls.addressee_last_name.hasError('required')) {
            <mat-error>
              Apellido <strong>requerido</strong>
            </mat-error>
            }
            <mat-autocomplete #autoLastName="matAutocomplete">
              @for (option of filteredOptionsLastName | async; track option) {
              <mat-option [value]="option.lastName">
                {{option.lastName}}
              </mat-option>
              }
            </mat-autocomplete>
          </mat-form-field>
        </div>
        <div class="flex-row filatres">
          <div class="phone-group">
            <mat-form-field class="prefix-section">
              <mat-select required formControlName="addressee_country">
                @for (phonePrefix of phonePrefixes; track phonePrefix) {
                <mat-option [value]="phonePrefix.prefix">
                  {{phonePrefix.code}}
                </mat-option>
                }
              </mat-select>
            </mat-form-field>
            <mat-form-field class="phone">
              <mat-label>Móvil para sms de firma</mat-label>
              <input matInput formControlName="addressee_phone"
                [required]="processConfigForm.controls.addressee_phone.hasError('required')">
              @if (processConfigForm.controls.addressee_phone.hasError('required')) {
              <mat-error>
                Móvil <strong>requerido</strong>
              </mat-error>
              }
              @if (processConfigForm.controls.addressee_phone.hasError('minlength') ||
              processConfigForm.controls.addressee_phone.hasError('maxlength')) {
              <mat-error>
                Móvil <strong>debe tener 9 caracteres</strong>
              </mat-error>
              }
              @if (processConfigForm.controls.addressee_phone.hasError('pattern')) {
              <mat-error>
                Móvil <strong>debe ser numérico</strong>
              </mat-error>
              }
            </mat-form-field>
          </div>
          <mat-form-field class="email">
            <mat-label>Email</mat-label>
            <input matInput placeholder="Ex. pat@example.com" formControlName="addressee_mail"
              [required]="processConfigForm.controls.addressee_mail.hasError('required')">
            @if (processConfigForm.controls.addressee_mail.hasError('email') &&
            !processConfigForm.controls.addressee_mail.hasError('required')) {
            <mat-error>
              Por favor ingrese un correo válido
            </mat-error>
            }
            @if (processConfigForm.controls.addressee_mail.hasError('required')) {
            <mat-error>
              Correo <strong>requerido</strong>
            </mat-error>
            }
          </mat-form-field>
        </div>
      </div>
      <div class="flex-row">
        <mat-form-field class="expediente">
          <mat-label>Nº Expediente</mat-label>
          <input matInput formControlName="expedient" required>
        </mat-form-field>
        <div class="switch-button">
          <label class="varios-firmantes">¿Enviar instrucciones por email?</label>
          <input type="checkbox" name="switch-button" id="switch-label" class="switch-button__checkbox"
            (click)="checkSendEmail($event)" checked>
          <label for="switch-label" class="switch-button__label"></label>
        </div>
      </div>
      <div class="flex-row">
        @if (optionsCompany.length > 0) {
        <mat-form-field>
          <mat-label>Empresa</mat-label>
          <mat-select required formControlName="company">
            @for (company of optionsCompany; track company) {
            <mat-option [value]="company.uuid">
              {{company.name}}
            </mat-option>
            }
          </mat-select>
          @if (processConfigForm.controls.company.hasError('required')) {
          <mat-error>
            Empresa <strong>requerido</strong>
          </mat-error>
          }
        </mat-form-field>
        }
      </div>
      <div class="enviar2">
        <input type="button" (click)="cancel()" class="boton volver2" value="Cancelar">
        <input type="submit" class="boton volver2" value="Iniciar Proceso" [disabled]="buttonSend">
      </div>
    </form>
  </div>
  }
</div>